<template>
  <div class="counter">
    <nav>
      <p>人工激活</p>
      <a href="javascript: void(0)" class="nav-button" @click="$router.push('/')">返回</a>
    </nav>

    <div class="search-container">
      <div style="flex: 1;" class="input-container">
        <label>手機號碼</label>
        <input type="text" maxlength="11" id="phone" v-model="phone" />
      </div>

      <button @click="getInvitations">Search</button>
    </div>

    <ul class="list-container">
      <li class="list-item" v-for="item, index in items" :key="item._id">
        <p style="text-align: right;">
          <span class="left">{{ item.ticketVariant.event.title }}</span>
          <span v-if="activating !== index" @click="() => activate(item._id, index)" class="activated">激活</span>
          <span v-else class="activated"><div class="lds-ring xs"><div></div><div></div><div></div><div></div></div></span>
        </p>
        <p style="font-size: inherit;" class="subtitle">({{ item.ticketVariant.name }})</p>
        <p class="subtitle">#{{ item._id }}</p>
        <p class="subtitle">{{ item.lastActivatedAt && getDateTime(item.lastActivatedAt) }}</p>
        <p class="subtitle">激活次數: {{ item.activated }}</p>
      </li>
      <li v-if="loading" class="load-more">
        <div class="lds-ring small"><div></div><div></div><div></div><div></div></div>
      </li>
    </ul>
  </div>
</template>

<script>
import ScrollNext from '@/components/ScrollNext'
import { ticket } from '@/api'

export default {
  data() {
    return {
      phone: '',

      loading: false,
      items: [],

      activating: -1,
    }
  },
  methods: {
    activate(id, index) {
      this.activating = index;
      ticket.activate(id).then(({ data: ticket }) => {
        this.$set(this.items, index, ticket);
        this.activating = -1;
      });
    },
    getInvitations() {
      if (!this.phone || this.phone.length !== 11) return;

      this.loading = true
      ticket.get(encodeURIComponent(`+86${this.phone}`)).then((response) => {
        this.items = response.data.tickets
        this.loading = false
      }).catch(response => {
        this.loading = false
      })
    },
    getDateTime(item) {
      let date = new Date(item)
      return `${date.toLocaleDateString("zh-TW")} ${date.toLocaleTimeString("zh-TW")}`
    }
  },
  components: {
    ScrollNext,
  },
}
</script>

<style scoped>
.lds-ring.small {
  height: 40px;
  width: 40px;
}

.lds-ring.small div {
  height: 30px;
  width: 30px;

  border-width: 3px;
}

.lds-ring.xs {
  vertical-align: top;

  height: 18px;
  width: 18px;
}

.lds-ring.xs div {
  height: 13px;
  width: 13px;

  margin: 3px;
  border-width: 1px;
}

.left {
  float: left !important;
}
.right {
  float: right;
}
.counter {
  padding-top: 60px;

  height: 100%;
  width: 100%;
  background: white;

  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
nav {
  height: 60px;
  width: 100%;
  background: rgb(243,243,243);
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.13);

  position: fixed;
  top: 0;
  z-index: 1;
}
nav p {
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 20px;
}
.nav-button {
  height: 100%;
  padding: 0 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  text-decoration: none;
  color: #2987e0;

  position: absolute;
  right: 0;
  top: 0;
}

.search-container {
  display: flex;
  align-items: center;

  padding: 16px;
  padding-left: 0px;
  border-bottom: 1px solid lightgrey;
}

.search-container button {
  display: block;
  padding: 8px 16px;
}

.list-container .load-more {
  padding: 20px;
  border-bottom: 1px solid lightgrey;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 30px;
  font-weight: bold;
}
.list-item {
  position: relative;
  padding: 10px 15px;
  color: rgb(50,50,50);
}
.list-item .subtitle {
  text-align: left;
  color: grey;
  font-size: 10px;
}
.activated {
  border-radius: 6px;
  padding: 3px 8px;
  color: white;
  background: rgb(45, 171, 40);
}
.activated:hover {
  cursor: pointer;
}

.list-item:after {
  position: absolute;
  height: 1px;
  right: 0;
  bottom: 0;
  background: lightgrey;
  left: 40px;
  content: '';
}
</style>
